<template>
  <div class="finance-admin">
    <el-alert type="error" v-if="info.auditStatus === 2" :title="'结算账户信息审核失败，请及时处理。审核失败原因：' + info.auditFailReason" banner closable style="margin-bottom: 16px"/>
    <el-row>
      <el-col>
        <div class="finance-title">账户主体信息</div>
        <el-form label-width="135px" :model="form" ref="form" @submit="handleSubmit" style="margin-top: 20px;width: 100%;">
          <el-form-item label="开户账户类型" prop="mchType" :rules="[{required: false, message: '请选择', trigger: 'change'}]">
            <el-select style="width: 400px;" v-if="isEdit" v-model="mchType" placeholder="请选择开户账户类型" filterable :clearable="false">
              <el-option v-for="(item,index) in Tool.map2arr($enums.mchType)" :key="index" :label="item.value" :value="item.key" :class="item.disabled?'none':''"></el-option>
            </el-select>
            <div v-else>{{types[info.mchType]}}</div>
          </el-form-item>
          <!-- 个人 -->
          <template v-if="mchType == 0">
            <el-form-item label="开户人姓名" prop="mchName" :rules="[$validate.string2(30)]">
              <el-input style="width: 400px;" v-if="isEdit" v-model="form.mchName" :maxLength="30" placeholder="开户人姓名"/>
              <div v-else>
                <span>{{info.mchNameEye ? info.mchName2 : info.mchName}} <i :class="info.mchNameEye ? 'el-icon-view' : 'el-icon-view'" @click="changeEye('mchNameEye', info.mchNameEye)"/></span>
              </div>
            </el-form-item>
            <el-form-item label="开户人证件类型" prop="idType" :rules="[{required: true, message: '请选择', trigger: 'change'}]">
              <el-select style="width: 400px;" v-if="isEdit" v-model="form.idType" placeholder="请选择开户人证件类型" filterable :clearable="false">
                <el-option v-for="(item,index) in Tool.map2arr($enums.financeIdType1)" :key="index" :label="item.value" :value="item.key" :class="item.disabled?'none':''"></el-option>
              </el-select>
              <div v-else>{{$enums.financeIdType1[info.idType]}}</div>
            </el-form-item>
            <el-form-item label="开户账户证件号码" prop="idNo" :rules="[$validate.string2(22)]">
              <el-input style="width: 400px;" v-if="isEdit" v-model="form.idNo" :maxLength="30" placeholder="开户账户证件号码"/>
              <div v-else>
                <span>{{info.idNoEye ? info.idNo2 : info.idNo}} <i :class="info.idNoEye ? 'el-icon-view' : 'el-icon-view'" @click="changeEye('idNoEye', info.idNoEye)"/></span>
              </div>
            </el-form-item>
            <el-form-item label="联系人姓名" prop="contactPerson" :rules="[$validate.string2(20)]">
              <el-input style="width: 400px;" v-if="isEdit" v-model="form.contactPerson" :maxLength="20" placeholder="联系人姓名"/>
              <div v-else>
                <span v-if="info.contactPerson">{{info.contactEye ? info.contactPerson2 : info.contactPerson}} <i :class="info.idNoEye ? 'el-icon-view' : 'el-icon-view'"
                                                                                                                  @click="changeEye('contactEye', info.contactEye)"/></span>
              </div>
            </el-form-item>
          </template>
          <!-- 个体 -->
          <template v-if="mchType == 1">
            <el-form-item label="商户名称" prop="mchName" :rules="[$validate.string2(20)]">
              <el-input style="width: 400px;" v-if="isEdit" v-model="form.mchName" :maxLength="30" placeholder="商户名称"/>
              <div v-else>
                <span>{{info.mchNameEye ? info.mchName2 : info.mchName}} <i :class="info.mchNameEye ? 'el-icon-view' : 'el-icon-view'" @click="changeEye('mchNameEye', info.mchNameEye)"/></span>
              </div>
            </el-form-item>
            <el-form-item label="证件类型" prop="idType" :rules="[{required: true, message: '请选择', trigger: 'change'}]">
              <el-select style="width: 400px;" v-if="isEdit" v-model="form.idType" placeholder="请选择开户账户类型" filterable :clearable="false">
                <el-option v-for="(item,index) in Tool.map2arr($enums.financeIdType1)" :key="index" :label="item.value" :value="item.key" :class="item.disabled?'none':''"></el-option>
              </el-select>
              <div v-else>{{$enums.financeIdType1[info.idType]}}</div>
            </el-form-item>
            <el-form-item label="商户证件号码" prop="idNo" :rules="[$validate.string2(30)]">
              <el-input style="width: 400px;" v-if="isEdit" v-model="form.idNo" :maxLength="30" placeholder="商户证件号码"/>
              <div v-else>
                <span>{{info.idNoEye ? info.idNo2 : info.idNo}} <i :class="info.idNoEye ? 'el-icon-view' : 'el-icon-view'" @click="changeEye('idNoEye', info.idNoEye)"/></span>
              </div>
            </el-form-item>
            <el-form-item label="联系人姓名" prop="contactPerson" :rules="[$validate.string2(20)]">
              <el-input style="width: 400px;" v-if="isEdit" v-model="form.contactPerson" :maxLength="20" placeholder="联系人姓名"/>
              <div v-else>
                          <span v-if="info.contactPerson">{{info.contactEye ? info.contactPerson2 : info.contactPerson}} <i :class="info.idNoEye ? 'el-icon-view' : 'el-icon-view'"
                                                                                                                            @click="changeEye('contactEye', info.contactEye)"/></span>
              </div>
            </el-form-item>
          </template>
          <!-- 企业 -->
          <template v-if="mchType == 2">
            <el-form-item label="企业名称" prop="mchName" :rules="[$validate.string2(30)]">
              <el-input style="width: 400px;" v-if="isEdit" v-model="form.mchName" :maxLength="30" placeholder="企业名称"/>
              <div v-else>
                <span>{{info.mchNameEye ? info.mchName2 : info.mchName}} <i :class="info.mchNameEye ? 'el-icon-view' : 'el-icon-view'" @click="changeEye('mchNameEye', info.mchNameEye)"/></span>
              </div>
            </el-form-item>
            <el-form-item label="证件类型" prop="idType" :rules="[{required: true, message: '请选择', trigger: 'change'}]">
              <el-select style="width: 400px;" v-if="isEdit" v-model="form.idType" placeholder="请选择证件类型" filterable :clearable="false">
                <el-option v-for="(item,index) in Tool.map2arr($enums.financeIdType2)" :key="index" :label="item.value" :value="item.key" :class="item.disabled?'none':''"></el-option>
              </el-select>
              <div v-else>{{$enums.financeIdType2[info.idType]}}</div>
            </el-form-item>
            <el-form-item label="企业证件号码" prop="idNo" :rules="[$validate.string2(30)]">
              <el-input style="width: 400px;" v-if="isEdit" v-model="form.idNo" :maxLength="30" placeholder="企业证件号码"/>
              <div v-else>
                <span>{{info.idNoEye ? info.idNo2 : info.idNo}} <i :class="info.idNoEye ? 'el-icon-view' : 'el-icon-view'" @click="changeEye('idNoEye', info.idNoEye)"/></span>
              </div>
            </el-form-item>
            <el-form-item label="联系人姓名" prop="contactPerson" :rules="[$validate.string2(20)]">
              <el-input style="width: 400px;" v-if="isEdit" v-model="form.contactPerson" :maxLength="20" placeholder="联系人姓名"/>
              <div v-else>
                          <span v-if="info.contactPerson">{{info.contactEye ? info.contactPerson2 : info.contactPerson}} <i :class="info.idNoEye ? 'el-icon-view' : 'el-icon-view'"
                                                                                                                            @click="changeEye('contactEye', info.contactEye)"/></span>
              </div>
            </el-form-item>
          </template>
          <el-form-item label="联系人手机号" prop="mobile" :rules="[$validate.string2(11)]">
            <el-input style="width: 400px;" v-if="isEdit" v-model="form.mobile" :maxLength="11" placeholder="联系人手机号"/>
            <div v-else>
              <span>{{info.mobileEye ? info.mobile2 : info.mobile}} <i :class="info.mobileEye ? 'el-icon-view' : 'el-icon-view'" @click="changeEye('mobileEye', info.mobileEye)"/></span>
            </div>
          </el-form-item>
          <el-form-item v-if="!isEdit" label="审核状态">
            <div>{{$enums.financeAuditStatus[info.auditStatus]}}</div>
          </el-form-item>
          <el-form-item style="padding-left: 12px" :rules="[{required: true, message: '请选择', trigger: 'change'}]">
            <el-checkbox v-if="isEdit" v-model="checked">
              我已阅读并同意<a href="#" @click="handleOpenAgreement">《平安银行“见证宝”商户服务协议》</a>
            </el-checkbox>
          </el-form-item>
          <el-form-item v-if="isEdit">
            <el-button type="primary" ghost style="margin-right: 10px" v-show="info.mchId" @click="handleCancel">取消</el-button>
            <el-button type="primary" @click="handleSubmit">提交</el-button>
          </el-form-item>
        </el-form>
        <div v-if="info.cashStatus >2" class="finance-title">绑定银行卡信息</div>
        <div v-if="info.cashStatus >2">
          <el-form>
            <div v-if="mchType == 0">
              <div>
                <el-form-item label="银行商户类型">
                  <span v-if="mchType == 0">个人商户</span>
                  <span v-if="mchType == 1">个体商户</span>
                  <span v-if="mchType == 2">企业商户</span>
                </el-form-item>
              </div>
              <div>
                <el-form-item label="银行卡号">
                             <span>{{info.bankCardNoEye ? info.bankCardNo2 : info.bankCardNo}} <i :class="info.bankCardNoEye ? 'el-icon-view' : 'el-icon-view'"
                                                                                                  @click="changeEye('bankCardNoEye', info.bankCardNoEye)"/></span>
                </el-form-item>
              </div>
              <div>
                <el-form-item label="银行卡所属银行">
                  <span>{{info.bankName}}</span>
                </el-form-item>
              </div>
            </div>
            <div v-if="mchType == 1">
              <div>
                <el-form-item label="银行商户类型">
                  <span v-if="mchType == 0">个人商户</span>
                  <span v-if="mchType == 1">个体商户</span>
                  <span v-if="mchType == 2">企业商户</span>
                </el-form-item>
              </div>
              <div>
                <el-form-item label="银行卡号">
                            <span>{{info.bankCardNoEye ? info.bankCardNo2 : info.bankCardNo}} <i :class="info.bankCardNoEye ? 'el-icon-view' : 'el-icon-view'"
                                                                                                 @click="changeEye('bankCardNoEye', info.bankCardNoEye)"/></span>
                </el-form-item>
              </div>
              <div>
                <el-form-item label="银行卡所属银行">
                  <span>{{info.bankName}}</span>
                </el-form-item>
              </div>
              <div>
                <el-form-item label="公司名称">
                  <span>{{info.companyName}}</span>
                </el-form-item>
              </div>
              <div>
                <el-form-item label="公司证件类型">
                  <span v-if="info.companyIdType == 52">组织机构代码证</span>
                  <span v-if="info.companyIdType == 68">营业执照</span>
                  <span v-if="info.companyIdType == 73">统一社会信用代码</span>
                </el-form-item>
              </div>
              <div>
                <el-form-item label="公司证件号码">
                           <span>{{info.rcompanyIdNoEye ? info.companyIdNo2 : info.companyIdNo}} <i :class="info.rcompanyIdNoEye ? 'el-icon-view' : 'el-icon-view'"
                                                                                                    @click="changeEye('rcompanyIdNoEye', info.rcompanyIdNoEye)"/></span>
                </el-form-item>
              </div>
            </div>
            <div v-if="mchType == 2">
              <div>
                <el-form-item label="银行商户类型">
                  <span v-if="mchType == 0">个人商户</span>
                  <span v-if="mchType == 1">个体商户</span>
                  <span v-if="mchType == 2">企业商户</span>
                </el-form-item>
              </div>
              <div>
                <el-form-item label="银行卡号">
                          <span>{{info.bankCardNoEye ? info.bankCardNo2 : info.bankCardNo}} <i :class="info.bankCardNoEye ? 'el-icon-view' : 'el-icon-view'"
                                                                                               @click="changeEye('bankCardNoEye', info.bankCardNoEye)"/></span>
                </el-form-item>
              </div>
              <div>
                <el-form-item label="银行卡所属银行">
                  <span>{{info.bankName}}</span>
                </el-form-item>
              </div>
              <div>
                <el-form-item label="法人名称">
                  <span>{{info.reprNameEye ? info.reprName2 : info.reprName}} <i :type="info.reprNameEye ? 'el-icon-view' : 'el-icon-view'" @click="changeEye('reprNameEye', info.reprNameEye)"/></span>
                </el-form-item>
              </div>
              <div>
                <el-form-item label="法人证件类型">
                  <span v-if="info.reprIdType == 1">身份证</span>
                  <span v-if="info.reprIdType == 3">港澳台居民通行证(即回乡证)</span>
                  <span v-if="info.reprIdType == 4">中国护照</span>
                  <span v-if="info.reprIdType == 5">台湾居民来往大陆通行证(即台胞证)</span>
                  <span v-if="info.reprIdType == 19">外国护照</span>
                </el-form-item>
              </div>
              <div>
                <el-form-item label="法人证件号码">
                  <span>{{info.reprIdNoEye ? info.reprIdNo2 : info.reprIdNo}} <i :class="info.reprIdNoEye ? 'el-icon-view' : 'el-icon-view'"
                                                                                 @click="changeEye('reprIdNoEye', info.reprIdNoEye)"/></span>
                </el-form-item>
              </div>
            </div>
          </el-form>
        </div>
        <div v-if="info.auditStatus === 1" class="box-footer">
          <div style="margin-bottom: 6px">平安银行-企业网上银行</div>
          <div style="margin-bottom: 6px"><a href="https://ebank.orangebank.com.cn/corporbank/queryEbusinessJianZheng.do" target="_blank">https://ebank.orangebank.com.cn/corporbank/queryEbusinessJianZheng.do</a>
            <el-button type="link" @click="handleCopy">复制</el-button>
          </div>
          <div class="tips">*注：通过链接，可进入网上银行-查询登录页面，根据提示输入开户账户信息内容，可查询账户。</div>
        </div>
      </el-col>
      <el-col :span="8" style="text-align: right" v-if="!isEdit">
        <el-button type="primary" v-if="info.auditStatus === 2" @click="handleChangeEdit">重新编辑</el-button>
      </el-col>
    </el-row>
    <textarea ref="copyServerSetting" style="position: fixed;top: 10000px;left: 10000px;opacity: 0;"></textarea>
  </div>
</template>
<script>
/* eslint-disable */

// import ApiFinanceProxy from '@/apis/api-finance-proxy'
import Tool from '../../common/tool'

export default {
  name: 'finance-admin',
  data () {
    const types = {
      0: '个人商户',
      1: '个体工商户',
      2: '企业商户'
    }
    return {
      types: types,
      form: {},
      mchType: 2,
      checked: false,
      agentId: this.$store.state.currentUserInfo.agentId,
      agentName: this.$store.state.currentUserInfo.agentName,
      collegeName: '',
      isEdit: true,
      info: {},
      oldMchType: 0,
      oldIdType: ''
    }
  },
  // async beforeCreate () {
  //   Tool.setTitle('', this.$route.path)
  // },
  async created () {
    // this.collegeId = this.$store.getters.getCurrentUserInfo.perm.collegeBrief.collegeId
    // this.collegeName = this.$store.getters.getCurrentUserInfo.perm.collegeBrief.collegeName
    await this.initData()
  },
  async mounted () {

  },
  methods: {
    async initData () {
      const data = await this.$HTTP.ApiFinanceProxy.getMerchantInfo(this.agentId) || {}
      this.oldMchType = data.mchType
      this.oldIdType = data.idType
      this.mchType = data.mchType || 2
      data.mobile2 = data.mobile ? data.mobile.replace(/^(\d{3})(\d{4})(\d{4})/g, '$1****$3') : ''
      data.mobileEye = true
      data.idNo2 = data.idNo ? data.idNo.replace(/^(.{6})(?:\w+)/, '\$1********') : ''
      data.bankCardNo2 = data.bankCardNo ? data.bankCardNo.replace(/^(.{6})(?:\w+)/, '\$1********') : ''
      data.idNoEye = true
      data.bankCardNoEye = true
      data.reprIdNo2 = data.reprIdNo ? data.reprIdNo.replace(/^(.{6})(?:\w+)/, '\$1********') : ''
      data.reprIdNoEye = true
      data.reprName2 = data.reprName ? data.reprName.replace(/(?<=.)./g, '*') : ''
      data.reprNameEye = true
      data.companyIdNo2 = data.companyIdNo ? data.companyIdNo.replace(/^(.{6})(?:\w+)/, '\$1********') : ''
      data.rcompanyIdNoEye = true
      data.contactPerson2 = data.contactPerson ? data.contactPerson.replace(/(?<=.)./g, '*') : ''
      data.contactEye = true
      data.mchName2 = data.mchName ? data.mchName.replace(/(?<=.)./g, '*') : ''
      data.mchNameEye = true
      if (data.mchId) {
        this.isEdit = false
      }
      this.info = data
    },
    mchTypeChange (value) {
      this.mchType = value
      if (this.mchType === this.oldMchType) {
        this.info.idType = this.oldIdType
      } else {
        this.info.idType = undefined
      }
      this.form.setFieldsValue({
        info: this.info
      })
    },
    validateChecked (rule, value, callback) {
      const form = this.form
      if (value) {
        callback()
      } else {
        callback('请阅读并勾选服务协议')
      }
    },
    async handleSubmit () {
      try {
        let confirm = await this.$confirm('请确保填写的信息无误，提交后不能更改账户信息', '提示', { type: 'warning' })
        if (confirm === 'confirm') {
          let isOK = await this.Tool.checkForm(this.$refs['form'])
          if (isOK && this.checked) {
            if (this.info.mchId) {
              await this.$HTTP.ApiFinanceProxy.merchantUpdate({
                ...this.form,
                mchType: this.mchType,
                originalId: this.agentId,
                originalName: this.agentName,
                appId: '21188075522202009676dfd1c0522d03',
                mchId: this.info.mchId,
                isMchCharge: 0
              })
              this.$message.success('操作成功')
              await this.initData()
            } else {
              await this.$HTTP.ApiFinanceProxy.merchantAdd({
                ...this.form,
                mchType: this.mchType,
                originalId: this.agentId,
                originalName: this.agentName,
                appId: '21188075522202009676dfd1c0522d03',
                isMchCharge: 0
              })
              this.$message.success('操作成功')
              await this.initData()
            }
          } else {
            this.$message.error('请阅读并勾选服务协议')
          }
        }
      } catch (e) {
        this.Tool.doError(e)
      }
    },
    handleOpenAgreement () {
      // to do
      window.open('https://my.orangebank.com.cn/orgLogin/hd/act/jianzb/jzbxy.html')
    },
    handleChangeEdit () {
      this.isEdit = !this.isEdit
    },
    // 脱敏处理
    changeEye (key, value) {
      this.info[key] = !value
    },
    handleCancel () {
      this.isEdit = false
      this.info.mchType = this.oldMchType
      this.info.idType = this.oldIdType
      this.mchType = this.oldMchType
      // this.form.setFieldsValue({
      //   info: this.info
      // })
    },
    async handleCopy () {
      this.$refs.copyServerSetting.value = 'https://ebank.orangebank.com.cn/corporbank/queryEbusinessJianZheng.do'
      this.$refs.copyServerSetting.select()
      document.execCommand('copy')
      this.$message.success('复制成功')
    }
  }
}
</script>
<style scoped>

  .box-footer {
    padding: 20px;
    background-color: #f1f1f165;
  }

  .box-footer .tips {
    color: #f56c6c;
    font-size: 12px;
  }

  /*.finance-admin .finance-title {*/
  /*  font-size: 16px;*/
  /*  font-weight: 600;*/
  /*}*/

  /*.finance-admin .finance-container {*/
  /*  margin-top: 20px*/
  /*}*/

  .labelFont {
    margin: 20px 30px;
    display: inline-block;
  }
</style>
